import { render } from "./Edit.vue?vue&type=template&id=18dbdf24"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=18dbdf24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PhysicalInventory/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18dbdf24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18dbdf24', __exports__)) {
    api.reload('18dbdf24', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=18dbdf24", () => {
    api.rerender('18dbdf24', render)
  })

}


export default __exports__